import React from 'react'

import styles from './Content.module.scss'

const Content = ({ maxWidth, fontSize,backgroundColor, ...rest }) => (
  <div {...rest} className={styles.base} style={{ maxWidth, fontSize,backgroundColor }} />
)

export default Content
